import { createSelector } from 'reselect'

const interactiveVideoData = state => state.interactiveVideoCreation

const getBreakpointFromClientIdSelector = clientBreakpointId => createSelector(
	[ interactiveVideoData ],
	interactiveVideoData =>
		interactiveVideoData.media.breakpoints.find(
			breakpoint => breakpoint.clientId === clientBreakpointId
		)
)

const getBreakpointFromUidSelector = breakpointUid => createSelector(
	[ interactiveVideoData ],
	interactiveVideoData =>
		interactiveVideoData.media.breakpoints.find(
			breakpoint => breakpoint.uid === breakpointUid
		)
)

export {
	getBreakpointFromClientIdSelector,
	getBreakpointFromUidSelector,
}
